import * as types from './actionTypes/anti-virus';
import AntivirusResponseModel_ from '../../data/models/AntivirusResponse';

export interface IAntiVirusActionType {
    type: typeof types.SET_ANTIVIRUS_STATUS;
    payload: AntivirusResponseModel_;
}

export const setAntivirusResponse = (data: AntivirusResponseModel_) => ({ type: types.SET_ANTIVIRUS_STATUS, payload: data, });
